var map = {
	"./arrow-left.svg": 5839,
	"./arrow-right.svg": 7402,
	"./cart.svg": 6162,
	"./chevron-down.svg": 5654,
	"./chevron-l.svg": 9414,
	"./chevron-left.svg": 8893,
	"./chevron-r.svg": 9072,
	"./chevron-right.svg": 3984,
	"./chevron-up.svg": 8365,
	"./close.svg": 9580,
	"./error.svg": 9194,
	"./facebook.svg": 8620,
	"./instagram.svg": 108,
	"./left.svg": 6931,
	"./menu.svg": 1997,
	"./minus.svg": 96,
	"./pinterest.svg": 2702,
	"./plane.svg": 294,
	"./play.svg": 9878,
	"./plus.svg": 8392,
	"./right.svg": 5686,
	"./search.svg": 5460,
	"./star-2.svg": 7141,
	"./star.svg": 9800,
	"./twitter.svg": 4125,
	"./user.svg": 6025,
	"./youtube.svg": 2163
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3216;